module.exports = __webpack_public_path__ + "img/teacher3d.5b08d04c.png";